import {
  QueryFunction, QueryKey, UseQueryOptions, useQuery,
} from '@tanstack/react-query';
import { useGlobalLoading } from 'Utils/GlobalLoading';
import { useEffect } from 'react';

export const useGlobalQuery = <F = unknown, E = unknown, D = F, K extends QueryKey = QueryKey>(
  queryKey: K,
  queryFn: QueryFunction<F, K>,
  config?: Omit<UseQueryOptions<F, E, D, K>, 'queryKey' | 'queryFn' | 'initialData'> & {
    initialData?: () => undefined;
  },
) => {
  const { startLoading, endLoading } = useGlobalLoading(queryKey);
  const queryResult = useQuery<F, E, D, K>(queryKey, queryFn, config);

  useEffect(() => {
    if (queryResult.isInitialLoading) startLoading();
    else endLoading();
  }, [queryResult.isInitialLoading]);

  useEffect(() => {
    if (queryResult.isFetched) endLoading();
  }, [queryKey]);

  return queryResult;
};
